// extracted by mini-css-extract-plugin
module.exports = {"container":"hero-page-module--container--1D86F","about":"hero-page-module--about--KfIXG"};